<template>
  <div>
    <v-autocomplete
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="lista"
      item-text="descripcion_sector"
      item-value="id_sector"
      label="Sector"
      persistent-hint
      return-object
      @change="$emit('input', select.id_sector)"
      hide-details
    ></v-autocomplete>
    <v-text-field
      outlined
      dense
      label="Sector"
      v-if="readonly===true"
      readonly
      filled
      :value="select.descripcion_sector"
      hide-details
    ></v-text-field>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      select: {
        id_sector: 0,
        descripcion_sector: ""
      }
    };
  },
  computed: {
    ...mapState("sectores", ["Lista"]),
    lista: function() {
      let l = [...this.Lista];
      l.unshift({
        id_sector: 0,
        descripcion_sector: " --Seleccione-- "
      });
      return l;
    }
  },
  methods: {
    seleccionar(id) {
      if (id !== null) {
        let pr = this.lista.find(x => x.id_sector == id);
        if (pr) {
          this.select = pr;
        } else {
          this.seleccionar("0");
        }
      }
    }
  },
  async mounted() {
    let id = this.value;
    this.seleccionar(id);
  },
  watch: {
    value() {
      this.seleccionar(this.value);
    }
  }
};
</script>

<style>
</style>